import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavBadgeService {
  private refresh$ = new Subject<void>();
  readonly onRefresh$ = this.refresh$.asObservable();

  refresh(): void {
    this.refresh$.next();
  }
}
